var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"shop"},[_c('div',[_c('ShoppingCart'),_c('ProductList')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }